export default {"src":"/_next/static/media/gym.936f0cbd.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};